const HTML_ENTITIES = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};

/**
 * Escapes HTML special characters in a value so it can be safely rendered
 * inside a v-html binding without being interpreted as markup.
 *
 * @param value value to escape (coerced to string)
 * @returns {string}
 */
export default function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, char => HTML_ENTITIES[char]);
}
